import { render, staticRenderFns } from "./AlertWarningIcon.vue?vue&type=template&id=2d79b4aa"
import script from "./AlertWarningIcon.vue?vue&type=script&lang=js"
export * from "./AlertWarningIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports